import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useInstantSearch } from "react-instantsearch";
export const CustomNoResults = () => {
    const { indexUiState } = useInstantSearch();
    return (_jsx("div", { className: "mt-3", children: _jsxs("p", { children: ["No results for ", _jsx("q", { children: indexUiState.query }), "."] }) }));
};
export default CustomNoResults;
